import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { editContent, saveContentsAsync, } from "../../modules/editor";
import { requestRefreshCafe24Token, requestShopProduct } from '../../modules/editor/service';
import { formatPriceWithCurrency } from '../../util/formatPriceWithCurrency';

import useDebounce from '../../hooks/useDebounce';

import ReactTooltip from 'react-tooltip';
import close from '../../assets/images/icon/close.png';
import search from '../../assets/images/icon/search.png';
import useAlert from '../../hooks/useAlert';
import { Shop } from '../../modules/editor';

type Props = {
	target: string;
	shopType: string;
	selectedShop: Shop;
}

function SelectedContentShopProduct({ target, shopType, selectedShop }: Props) {
	const [productList, setProductList] = useState([] as any);
	const [showProductList, setShowProductList] = useState(false);
	const [productListActiveIndex, setProductListActiveIndex] = useState(0);
	const [inputKeyTrigged, setInputKeyTrigged] = useState(false);
	const [debounceKeyword, keyword, setKeyword] = useDebounce<string>(
		'',
		200
	);
	
	const dispatch = useDispatch();
	const Alert = useAlert();

	useEffect(()=>{
		if (debounceKeyword.length === 0) {
			return;
		}
		getProducts();
	}, [debounceKeyword, selectedShop]);

	const getProducts = async() => {
		try {			
			const result = await requestShopProduct(keyword, selectedShop?.shop_no);
			setProductList(result || []);
			setShowProductList(true);
			// init
			setProductListActiveIndex(0);
			setInputKeyTrigged(false);

		} catch (error) {
			const { Code } = error.response.data;
			if (Code === 'Errors.Cafe24.ExpiredToken') {
				Alert.error(Alert?.msg?.CAFE24_NOT_INSTALLED);
				// refreshCafe24Token();
			}
			if (Code === 'Errors.Cafe24.NotInstalled') {
				Alert.error(Alert?.msg?.CAFE24_NOT_INSTALLED);
				// userInfoUpdate();
			}
			console.error(error);
		}
	}

	const onchange = (e: any) => {
		const { value } = e.target;
		setKeyword(value);
	}

	const onKeyDown = (e: any) => {
		e.stopPropagation();

		if (!inputKeyTrigged) {
			setInputKeyTrigged(true);
			return;
		}
		
		const { key, target: { value } } = e;

		if (key === 'ArrowDown') {
			if (productListActiveIndex + 1 >= productList.length) {
				setProductListActiveIndex(0);
				return;
			}
			setProductListActiveIndex(productListActiveIndex+1);
		}

		if (key === 'ArrowUp') {
			if (productListActiveIndex === 0) {
				setProductListActiveIndex(productList.length - 1);
				return;
			}
			setProductListActiveIndex(productListActiveIndex - 1);
		}

		if (key === 'Enter') {
			applyToContent(productListActiveIndex);
		}
	}

	const applyToContent = (activeIndex:number) => {
		const product = productList.find((item: any, index: number) => index === activeIndex);
		const { discountPrice, imageUrl, price, productDescription, productName, productUrl } = product;	

		const textAlign = shopType === 'shopB' ? 'left' : 'center';

		dispatch(editContent({ target: `${target}/0/imagePath`, data: imageUrl }));
		dispatch(editContent({ target: `${target}/0/imageLink`, data: productUrl }));

		dispatch(editContent({ target: `${target}/1/text`, data: `<div style='text-align:${textAlign};'><span style='font-size: 18px;'>${productName}</span></div>` }));

		dispatch(editContent({ target: `${target}/2/text`, data: `<div style='text-align: ${textAlign};'><span style='font-style: normal; text-decoration-line: line-through; color: #999999;font-size: 14px;'>${price.toLocaleString()}</span></div>` }));

		dispatch(editContent({ target: `${target}/3/text`, data: `<div style='text-align: ${textAlign};'><span style='font-style: normal; color: #000000;font-size: 14px;'>${discountPrice.toLocaleString()}</span></div>` }));

		dispatch(editContent({ target: `${target}/4/text`, data: `<div style='text-align: ${textAlign};'><span style='font-size: 12px; color: #999999;'>${productDescription.length === 0 ? '&nbsp;' : productDescription};</span></div>` }));

		dispatch(editContent({ target: `${target}/5/buttonLink`, data: productUrl }));

		if (shopType === 'shopB') {
			const sideTarget = `${target}`.replace('/0', '/1');
			dispatch(editContent({ target: `${sideTarget}/0/imagePath`, data: imageUrl }));
			dispatch(editContent({ target: `${sideTarget}/0/imageLink`, data: productUrl }));

			dispatch(editContent({ target: `${sideTarget}/1/text`, data: `<div style='text-align:${textAlign};'><span style='font-size: 18px;'>${productName}</span></div>` }));

			dispatch(editContent({ target: `${sideTarget}/2/text`, data: `<div style='text-align: ${textAlign};'><span style='font-style: normal; text-decoration-line: line-through; color: #999999;font-size: 14px;'>${price.toLocaleString()}</span></div>` }));

			dispatch(editContent({ target: `${sideTarget}/3/text`, data: `<div style='text-align: ${textAlign};'><span style='font-style: normal; color: #000000;font-size: 14px;'>${discountPrice.toLocaleString()}</span></div>` }));

			dispatch(editContent({ target: `${sideTarget}/4/text`, data: `<div style='text-align: ${textAlign};'><span style='font-size: 12px; color: #999999;'>${productDescription.length === 0 ? '&nbsp;' : productDescription};</span></div>` }));

			dispatch(editContent({ target: `${sideTarget}/5/buttonLink`, data: productUrl }));
		}

		dispatch(saveContentsAsync.request());

		initResult();
	}

	const refreshCafe24Token = async () => {
		try {
			const { url } = await requestRefreshCafe24Token();
			let newWin = document.createElement('iframe');
			newWin.setAttribute('id', 'checkcafe24token');
			newWin.setAttribute('style', 'width:10px;height:10px;position:fixed;top:-9999px;left:-9999px;');
			newWin.setAttribute('src', url);
			document.body.appendChild(newWin);
		} catch (error) {
			console.error(error);
		}		
	}

	const initResult = () => {
		setShowProductList(false);
		setProductList([]);
		setInputKeyTrigged(false);
		setKeyword('');
	}

	useEffect(() => {
		if (showProductList) {
			const titles = document.querySelectorAll('.title');
			titles.forEach((title) => {
				if (title.scrollWidth <= 271) {
					title.classList.add('no-tooltip');
				}
			});
		};
	}, [productList, showProductList]);

	return (
		<div className="field-section">
			<div className="shop-field-product">
				<div className="shop-field-product-inp">
					<input 
						type="text"
						value={keyword}
						placeholder="상품 이름을 입력하세요"
						onKeyDown={onKeyDown}
						onChange={onchange}
					/>
					{
						showProductList ? (
							<button 
								onClick={initResult}
							>
								<img src={close} alt="close" width="14"/>
							</button>
						) : (
							<button>
								<img src={search} alt="search" width="14" />
							</button>
						)
					}
				</div>
				{
					showProductList && productList.length !== 0 && (
						<div className="shop-field-product-body">
							<ul>
								{
									productList.map((item:any, index: number) => (
										<a data-tip data-for={item.productName} key={index}>
											<li 
												key={index}
												onClick={() => {applyToContent(index)}}
											>
													<div className="img" style={{ backgroundImage: `url(${item.thumbnailUrl})`}}>
													</div>
													<div className="cont">
														<h1 className="title" id={`title-${item.productName}`}>
															{item.productName}
															<ReactTooltip id={item.productName} effect='solid' place='bottom'>
																<div dangerouslySetInnerHTML={{__html:item.productName}}></div>
															</ReactTooltip>
														</h1>
														<span className="price">
															{formatPriceWithCurrency(item.discountPrice, selectedShop.currency)}
														</span>
														<a className="link" href={item.productUrl} target="_blank" onClick={(e) => e.stopPropagation() }>상품보기 </a>
													</div>
											</li>
										</a>
									))
								}
							</ul>
						</div>
					)
				}
				{
					showProductList && productList.length === 0 && (
						<div className="shop-field-product-body">
							<div className="empty">
								검색 결과가 없습니다.
							</div>
						</div>
					)
				}
			</div>
		</div>
	);
}

export default SelectedContentShopProduct;